import Cookies from "js-cookie";
import {
  forwardRef,
  Fragment,
  memo,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  Container,
  PopoverBody,
  PopoverHeader,
} from "reactstrap";
import {
  TOKEN_CLIENT_INFO,
  TOKEN_CLIENT_PARTNER,
  _PARTNER,
} from "../../../../../actions/constants";
import { randomCode } from "../../../../../actions/util";
import {
  CHECK_SUCCESS,
  CHECK_WARNING,
} from "../../../../../components/alert/Alert";
import {
  ButtonCustom,
  ButtonIcon,
} from "../../../../../components/base/Button";
import useSpeechToText, { Action } from "../../../../../hooks/useSpeechToText";
import {
  ConfigMeetsEndpoint,
  KetLuansEndpoint,
  PhienHopsEndpoint,
} from "../../../../../service/Meet";
import { AgentEndpoint } from "../../../../../service/SpeechToText";
import {
  Enum_Meeting_Status,
  _Enums_Template,
} from "../../../../action/defaultEnums";
import Tiptap from "../Note/Tiptap/Component/TipTap";
import Tooltip from "@mui/material/Tooltip";
import Jordit from "../../../../../components/other/Jodit";
import RecordAudio from "../DangKyPhatBieu/RecordAudio";
import DangKyPhatBieusEndpoint from "../../../../../service/Meet/DangKyPhatBieusEndpoint";
import DocumentViewer from "../../../../../others/DocViewer/components/DocumentViewer";
import { ListenAudio } from "../DangKyPhatBieu";
import { Paper, Divider, IconButton, Icon } from "@mui/material";
import { FontAwesome } from "../../../../../components/icon";
import { useSelector } from "react-redux";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CancelIcon from "@mui/icons-material/Cancel";
import { useAsync } from "../../../../../hooks";
import { Skeleton } from "@mui/lab";
import { Button } from "@mui/material";
import { CardHeader } from "@mui/material";
import { CardContent } from "@mui/material";
import { Card } from "@mui/material";
import { Popover } from "@mui/material";
import { Typography } from "@mui/material";
import { Stack } from "@mui/material";

export const AudioToText = memo(({ path }) => {
  const [data, setData] = useState(null);
  const [isCopy, setIsCopy] = useState(false);
  const refTimeOut = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const speechToText = useCallback(async () => {
    try {
      const cur = await PhienHopsEndpoint.speechToText(path);
      setData(cur.resultObj);
      return true;
    } catch (err) {
      return console.log(err);
    }
  }, [path]);

  const { execute, status } = useAsync(speechToText, false);

  useEffect(() => {
    anchorEl && execute();
  }, [execute, anchorEl]);

  useEffect(() => {
    if (isCopy) {
      refTimeOut.current = setTimeout(() => {
        setIsCopy(false);
        clearTimeout(refTimeOut.current);
      }, 2500);
    }
  }, [isCopy]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <span className="d-flex justify-content-between align-items-center">
      <Stack p={1} direction={"row"} alignItems="center">
        <Icon fontSize="small">audio_file</Icon>
        <h5 style={{ fontWeight: "bolder" }} className="mb-0">
          File Audio kết luận
        </h5>
      </Stack>

      <Tooltip title="Chuyển audio sang text">
        <IconButton
          color="primary"
          size="small"
          aria-describedby={id}
          variant="contained"
          onClick={handleClick}
        >
          <Icon>file_present</Icon>
        </IconButton>
      </Tooltip>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Card>
          <CardHeader
            title={
              <Stack direction={"row"} gap={2} alignItems="center">
                <h4 className="">
                  Audio <FontAwesome fa="arrow-right"></FontAwesome> Văn
                  bản{" "}
                </h4>
                <Tooltip title="Copy" arrow>
                  <IconButton
                    style={{ padding: "5px" }}
                    color={isCopy ? "primary" : "default"}
                    type="button"
                    onClick={() => {
                      navigator.clipboard.writeText(data);
                      setIsCopy(true);
                    }}
                    size="large"
                  >
                    <Icon>
                      {isCopy ? "check_circle_outline" : "content_copy"}{" "}
                    </Icon>
                  </IconButton>
                </Tooltip>
              </Stack>
            }
          ></CardHeader>
          <CardContent>
            {status === "pending" ? (
              <Skeleton animation="wave" />
            ) : (
              <>
                {data ? (
                  <b>{data}</b>
                ) : (
                  <div className="text-center">DỮ LIỆU RỖNG</div>
                )}
              </>
            )}
          </CardContent>
        </Card>
      </Popover>

      {/* <Popover
        placement="top"
        target="PopoverKetLuan"
        isOpen={open}
        style={{ maxWidth: "22rem" }}
        trigger="legacy"
        toggle={() => {
          setOpen((pre) => !pre);
        }}
      >
        <PopoverHeader>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              {" "}
              Audio <FontAwesome fa="arrow-right"></FontAwesome> Văn bản{" "}
            </div>
            <Tooltip title="Copy" arrow>
              <IconButton
                style={{ padding: "5px" }}
                color={isCopy ? "primary" : "default"}
                type="button"
                onClick={() => {
                  navigator.clipboard.writeText(data);
                  setIsCopy(true);
                }}
                size="large"
              >
                <Icon>{isCopy ? "check_circle_outline" : "content_copy"} </Icon>
              </IconButton>
            </Tooltip>
          </div>
        </PopoverHeader>
        <PopoverBody>
          {status === "pending" ? (
            <Skeleton animation="wave" />
          ) : (
            <>
              {data ? (
                <b>{data}</b>
              ) : (
                <div className="text-center">DỮ LIỆU RỖNG</div>
              )}
            </>
          )}
        </PopoverBody>
      </Popover> */}
    </span>
  );
});

const index = forwardRef(
  ({ isOpen, onClose, nameAgent, phienHopId, isChuTri }, ref) => {
    const [dataTemplate, setDataTemplate] = useState(null);
    const [stateMedia, setStateMedia] = useState(null);
    const [files, setFiles] = useState([]);
    const refListenAudio = useRef(null);
    const { phienHop } = useSelector((state) => state.meetingRProcess);
    // eslint-disable-next-line no-unused-vars
    const { stopConnect, startConnect, data, status } = useSpeechToText(
      phienHopId,
      Action.SPEECH_TO_TEXT,
    );
    const refIdKetLuan = useRef(null);
    const refContent = useRef();
    const refAudio = useRef();
    const visible = useRef();

    const prepareTemplate = useCallback(async () => {
      const { ketLuans } =
        await PhienHopsEndpoint.getTemplateKetLuan(phienHopId);
      const { resultObj } = await PhienHopsEndpoint.getAllFile(phienHopId);
      const filesPhien = [];
      resultObj.forEach((f) =>
        filesPhien.push({
          name: f["fileName"],
          moTa: f?.tags["moTa"],
          path: f.filePath,
        }),
      );
      setFiles(filesPhien);
      if (ketLuans.length > 0) {
        setDataTemplate(ketLuans[0].htmlData);
        refIdKetLuan.current = ketLuans[0].id;
        return;
      }
      const { value } = await ConfigMeetsEndpoint.getTemplateByCode(
        _Enums_Template.Conclusion,
      );
      const [content] = value;
      setDataTemplate(content?.name || "");
    }, [phienHopId]);

    useEffect(() => {
      if (data) {
        refNote.current && refNote.current.insertData(` ` + data);
      }
    }, [data]);

    const refNote = useRef();

    // eslint-disable-next-line no-unused-vars
    const checkAccessSpeechToText = async () => {
      if (!TOKEN_CLIENT_PARTNER) {
        try {
          const res = await AgentEndpoint.login({
            email: "toan2@aimed.edu.vn",
            password: "toan2@2022",
          });
          const {
            access_token,
            refresh_token,
            expire_after,
            expire_at,
            user_id,
          } = res;
          if (access_token && refresh_token) {
            Cookies.set("PARTNER_ACCESS_TOKEN", access_token);
            Cookies.set("PARTNER_REFRESH_TOKEN", refresh_token);
          }
          localStorage.setItem(
            _PARTNER,
            JSON.stringify({ expire_after, expire_at, agent_id: user_id }),
          );
          return true;
        } catch (error) {
          return false;
        }
      } else {
        return true;
      }
    };

    const getAgentAndSetMic = useCallback(async () => {
      try {
        // const access = await checkAccessSpeechToText();
        // if (access) {
        //     const dataChannel = await PhienHopsEndpoint.SearchAllow(`(${phienHopId})?$select=channelStatus,channelId,agentId`)
        //     const { data } = await AgentEndpoint.getAgents();
        //     const curAgent = data.find(cur => cur.name === nameAgent)
        //     startConnect(Action.SPEECH_TO_TEXT, curAgent?.agent_id, dataChannel);
        // }
      } catch (error) {}
    }, []);

    useEffect(() => {
      if (isOpen) {
        prepareTemplate();
      }
      return () => {
        setDataTemplate(null);
      };
    }, [prepareTemplate, isOpen]);

    const handleSaveAndExportPDF = useCallback(async () => {
      try {
        const html =
          refContent.current.getValue() || refNote.current.getValue();
        if (refIdKetLuan.current) {
          await KetLuansEndpoint.editKetLuan(refIdKetLuan.current, {
            htmlData: html,
            phienHopId,
          });
        } else {
          await KetLuansEndpoint.addKetLuan({ htmlData: html, phienHopId });
        }
        /** @type {Blob} */
        const file = await PhienHopsEndpoint.exportPDFByHtml(html);
        file.lastModifiedDate = new Date();
        const name = randomCode() + ".pdf";
        await PhienHopsEndpoint.UploadFile(phienHopId, {
          Type: "KetLuan",
          file: new File([file], name),
        });
        stopConnect();
        onClose();
      } catch (error) {
        CHECK_WARNING("Thao tác không thành công");
      }
    }, [onClose, phienHopId, stopConnect]);

    const handleStop = useCallback(
      async (content) => {
        if (content) {
          const { audio } = content;
          if (audio) {
            const { resultObj: path } =
              await DangKyPhatBieusEndpoint.saveAudioKetLuan({
                key: phienHopId,
                file: audio,
              });
            const pathFile = path;
            refListenAudio.current.reload();
            CHECK_SUCCESS("Đã lưu bản ghi âm kết luận", pathFile);
          }
        } else {
          throw new Error();
        }
      },
      [phienHopId],
    );

    const requestRecorder = useCallback(async () => {
      const { state } = await navigator.permissions.query({
        name: "microphone",
      });
      if (state === "denied") {
        return Promise.reject("Vui lòng cho phép ứng dụng truy cập Microphone");
      } else {
        return true;
      }
    }, []);

    // eslint-disable-next-line no-unused-vars
    const startRecording = useCallback(
      async (phatBieu, openRecoder = null) => {
        try {
          if (!["hidden", ""].includes(visible.current)) {
            const res = await requestRecorder();
            if (res) {
              // await recorder.current.start()
              setStateMedia((pre) => {
                let state = { ...pre };
                state = { ...state, data: { phienHopId }, isOpen: true };
                return state;
              });
            }
          }
        } catch (error) {
          CHECK_WARNING(error || "Thao tác không thành công!");
        }
      },
      [phienHopId, requestRecorder],
    );

    return (
      <Modal size="xl" isOpen={isOpen}>
        <ModalHeader toggle={onClose}>
          <div className="d-flex">
            <img src="/assets/icon/other/speechtotext.svg" alt="icon-table" />
            <div className="ml-1">Kết luận phiên họp</div>
          </div>
        </ModalHeader>
        <ModalBody style={{ padding: "1rem" }}>
          <div className="speech-text-container" style={{ height: "auto" }}>
            <Row>
              <Col md="8" style={{ height: "100%" }}>
                {(TOKEN_CLIENT_INFO.mainRole === "TK" || isChuTri) &&
                phienHop?.trangThai === Enum_Meeting_Status.DangHop ? (
                  <Fragment>
                    {dataTemplate ? (
                      <Jordit ref={refContent} isOpen={dataTemplate || ""} />
                    ) : (
                      <Tiptap
                        withPlaceholderExtension={true}
                        ref={refNote}
                        content={dataTemplate}
                        withToolbar={true}
                        withTaskListExtension={true}
                        withLinkExtension={true}
                        isFullExtension={true}
                        isAnimate={status}
                        actions={[
                          {
                            title: "Kết luận phiên họp",
                            render: (title, onClick) => (
                              <Tooltip title={title} arrow>
                                <ButtonIcon
                                  color="success"
                                  faSolid={true}
                                  fa="magnifying-glass-chart"
                                  onClick={onClick}
                                ></ButtonIcon>
                              </Tooltip>
                            ),
                            onClick: getAgentAndSetMic,
                            hidden: status,
                          },
                          {
                            title: "Dừng chuyển đổi",
                            render: (title, onClick) => (
                              <Tooltip title={title} arrow>
                                <ButtonIcon
                                  color="danger"
                                  faSolid={true}
                                  fa="stop"
                                  onClick={onClick}
                                ></ButtonIcon>
                              </Tooltip>
                            ),
                            onClick: stopConnect,
                            hidden: !status,
                          },
                        ]}
                      />
                    )}
                    <Row
                      className="d-flex justify-content-end mt-2"
                      style={{ paddingRight: "0.75rem" }}
                    >
                      {(TOKEN_CLIENT_INFO.mainRole === "TK" || isChuTri) && (
                        <ButtonCustom
                          className="mr-1"
                          onClick={handleSaveAndExportPDF}
                        >
                          <FileDownloadIcon
                            sx={{
                              fontSize: 14,
                              mr: 0.5,
                              verticalAlign: "middle",
                            }}
                          />
                          Xuất PDF - Lưu
                        </ButtonCustom>
                      )}
                      <ButtonCustom
                        color="danger"
                        onClick={() => {
                          stopConnect();
                          onClose();
                        }}
                      >
                        <CancelIcon
                          sx={{
                            fontSize: 14,
                            mr: 0.5,
                            verticalAlign: "middle",
                          }}
                        />
                        Hủy
                      </ButtonCustom>
                    </Row>
                  </Fragment>
                ) : (
                  <Fragment>
                    <DocumentViewer
                      isDefaultRender={true}
                      isEdit={false}
                      activeDoc={
                        files.find((cur) => cur.path.includes("KetLuan")) ||
                        null
                      }
                    />
                  </Fragment>
                )}
              </Col>
              <Col md="4" style={{ height: "auto" }}>
                <Container>
                  {(TOKEN_CLIENT_INFO.mainRole === "TK" || isChuTri) &&
                  phienHop?.trangThai === Enum_Meeting_Status.DangHop ? (
                    <Fragment>
                      <div className="d-flex mb-3">
                        <b>Ghi chú</b>: Chọn vào nút{" "}
                        <button
                          style={{ fontSize: "0.5rem" }}
                          disabled
                          className="mr-1 ml-1 btn-play"
                        >
                          <FontAwesome fa="play"></FontAwesome>
                        </button>{" "}
                        để bắt đầu ghi âm
                      </div>
                      <RecordAudio
                        ref={refAudio}
                        {...{
                          handleStop,
                          stateMedia,
                          noModal: true,
                          nameFileAudio: "Ket-luan.mp3",
                        }}
                      />
                      <Divider></Divider>
                      <Paper className="mb-2 p-2 mt-2" elevation={1}>
                        <AudioToText
                          path={`ghi-am-ket-luan/${phienHopId}/Ket-luan.mp3`}
                        />
                        <Divider className="mb-2 mt-1"></Divider>
                        <ListenAudio
                          ref={refListenAudio}
                          path={`ghi-am-ket-luan/${phienHopId}/Ket-luan.mp3`}
                        />
                      </Paper>
                    </Fragment>
                  ) : (
                    <Paper className="mb-2 mr-2 p-1" elevation={1}>
                      <AudioToText
                        path={`ghi-am-ket-luan/${phienHopId}/Ket-luan.mp3`}
                      />
                      <Divider className="mb-2 mt-1"></Divider>
                      <ListenAudio
                        path={`ghi-am-ket-luan/${phienHopId}/Ket-luan.mp3`}
                      />
                    </Paper>
                  )}
                </Container>
              </Col>
            </Row>
          </div>
        </ModalBody>
      </Modal>
    );
  },
);
export default memo(index);
